import React, { Component, PureComponent } from 'react'
import ReactDOM from 'react-dom'

import EditButton from '../buttons/EditButton'
import ConfirmationDialog from '../Breadcrumb/ConfirmationDialog'
import CONSTANTS from '../../constants'
import { pushEventToGTM } from '../../helpers/trackerManager'

import {
  Redirect,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import { CurrentStepSetAction, setDialogConfirmationStepChange } from '../../actions/action'

const mapStateToProps = state => state
const mapDispatchToProps = { CurrentStepSetAction, setDialogConfirmationStepChange }

class CarSummary extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      redirectToLocation: false
    }
    this.confirmAndRedirect = this.confirmAndRedirect.bind(this)
  }

  confirmAndRedirect(isRedirect) {
    if (isRedirect) {
      this.props.CurrentStepSetAction(3)
      this.setState({ redirectToLocation: true })
    }
    // Reset id of visible dialog step change.
    this.props.setDialogConfirmationStepChange('')
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.redirectToLocation) { this.setState({ redirectToLocation: false }) }
  }

  render() {
    return (
      <div className='carDetails carSummaryBlock'>
        <div className='carSummaryBlock--row'>
          {CONSTANTS.SITE_INFO.BRAND_CODE === 'C' && <i class="mark-icons car-icon"></i>}
          <span tabIndex="0" className='sectionTitle'>{CONSTANTS.LABELS.header_modification_vehicule}</span>
          <p> {CONSTANTS.SITE_INFO.BRAND_CODE !== 'C' && <i class="mark-icons car-icon"></i>}
            <h5 tabIndex="0" className='carDetails--title'>{(this.props.Name ? this.props.Name : '-')}</h5>
          </p>

          <div className='carDetails-other'>
            {this.props.Kilometrage && <div tabIndex="0" className='carDetails-infosTitle'> {CONSTANTS.LABELS.header_modification_km} : <span className='carDetails-infosTitle_detail'>{this.props.Kilometrage} {CONSTANTS.LABELS.vehicule_step2_km2}</span></div>}
            {this.props.Vin && <div tabIndex="0" className='carDetails-infosTitle  fixed-width__infos'> {CONSTANTS.LABELS.header_modification_vin} : <span className='carDetails-infosTitle_detail'>{this.props.Vin}</span></div>}
            {this.props.Imat && <div tabIndex="0" className='carDetails-infosTitle fixed-width__infos'> {CONSTANTS.LABELS.header_modification_immat} : <span className='carDetails-infosTitle_detail'>{this.props.Imat}</span></div>}
          </div>
        </div>

        {this.props.store.step > 3 && <EditButton onClick={(e) => {
          pushEventToGTM({
            pageName: 'all',
            eventAction: 'Redirection::Internal::Modify',
            eventLabel: 'header_modify_vehicule'
          })
          if (this.props.isExistPrestationWithForfait) { this.props.setDialogConfirmationStepChange('CarChange') } else {
            this.setState({ redirectToLocation: true })
            this.props.CurrentStepSetAction(3)
          }
        }}
        />}
        {this.props.store.visibaleDialogId == 'CarChange' && <ConfirmationDialog isConfirmedDialog={(e) => {
          this.confirmAndRedirect(e)
        }}
        />}
        {this.state.redirectToLocation &&
          <Redirect
            push
            to={{ pathname: `${CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}` }}
          />}
      </div>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CarSummary)
